import React,{ Component } from 'react';
import PropTypes from 'prop-types';

import {
  Row,
  Col,
  Button,
  FormText,
  FormGroup,
  Label,
  Collapse,
  Input,
  Popover,
  PopoverBody,
  Card,
  CardBody
} from 'reactstrap';

import Select from 'react-select';

import EngagementResponseInput from './EngagementResponseInput';
import CampaignCompletionInput from './CampaignCompletionInput';
import AudienceRadioInput from './AudienceRadioInput';

import CollapsingSection from '../../../shared/components/CollapsingSection';
import TagListInput from '../../../shared/components/TagListInput';
import GeofilterInput from '../../../shared/components/GeofilterInput';
import Form from '../../../shared/components/Form';
import RadioButtonAccordion from '../../../shared/components/RadioButtonAccordion';
import SelectInput from '../../../shared/components/SelectInput';

import InformationSVG from '../../../shared/assets/information.svg';

import find from 'lodash/find';

import {
  formatGeofilterSelectOptions,
  buildNestedList,
  typeOfContraints
} from '../../../shared/utils';

const INCLUDE_PREDICATE = '__INCLUDE_PREDICATE__',
  EXCLUDE_PREDICATE = '__EXCLUDE_PREDICATE__',
  ALL_PREDICATE = '__ALL_PREDICATE__',
  CUSTOM_PREDICATE = '__CUSTOM_PREDICATE__',
  NONE_RESPONSE_PREDICATE = '__NONE_RESPONSE_PREDICATE__';

class GuidedCampaignAudience extends Component {
  constructor(props){
    super(props);

    this.state = {
      isLoaded:false,
      isSaving:false,
      error:null,
      validationMessages:{},
      estimatedReach:null,
      hasClickedSave:false,
      selectedPredicate:null,
      selectedResponsePredicate:null,
      tooltipPredicate:null,
      noOverLap:false,
      selectedCampaignIsActive:false,
      responseSections: null
    };
  }

  componentDidMount(){
    Promise
      .all([
        this.props.loadCampaign(this.props.campaignId),
        this.props.loadKPIsForCampaign(this.props.campaignId),
        this.props.loadListOfStatesAndDMAs()
      ])
      .then(() => this.props.loadListOfConstraintsForAgency(this.props.agencyId))
      .then(() => {
        const {
          activeCampaignGeoFilterPredicate,
          activeCampaignConstraints,
          possibleStates,
        } = this.props;

        if(activeCampaignConstraints && activeCampaignConstraints.length > 0) {
          this.setState({constraintExclude: activeCampaignConstraints[0].exclude})
        }
        this.setState({isLoaded:true})

        if(activeCampaignGeoFilterPredicate === 'exclude'){
          this.setState({selectedPredicate:EXCLUDE_PREDICATE});
        } else if(activeCampaignGeoFilterPredicate === 'include'){
          this.setState({selectedPredicate:INCLUDE_PREDICATE});
        } else if(activeCampaignGeoFilterPredicate === 'zip'){
          this.setState({selectedPredicate:CUSTOM_PREDICATE});
        } else {
          this.setState({selectedPredicate:ALL_PREDICATE});
        }
      })
      .catch((err) => this.setState({error:err}));
    }

  handleSubmit(data){
    let selectedCampaign,selectedEngagement,selectedResponses;

    const validationMessages = {};

    const {
      targetCampaign,
      campaignId
    } = this.props;


    const campaigns = this.state.constraintExclude === true ? this.props.campaignFilters.filter(c => ['complete','outOfFunds'].indexOf(c.status) >= 0) : this.props.campaignFilters

    if(data.completedCampaignId){
      selectedCampaign = find(campaigns, (c) => c.id === data.completedCampaignId);
    } else if(data.responseCampaignId){
      selectedCampaign = find(campaigns, (c) => c.id === data.responseCampaignId);
    }

    if(data.responseEngagementId && selectedCampaign){
      selectedEngagement = find(selectedCampaign.engagements,(e) => e.id === data.responseEngagementId);
    }

    if(data.geofilterPredicate === 'exclude' && (!data.excludedFilters || data.excludedFilters.length === 0)){
      validationMessages['excludedFilters'] = 'You must select at least one filter';
    }

    if(data.geofilterPredicate === 'include' && (!data.includedFilters || data.includedFilters.length === 0)){
      validationMessages['includedFilters'] = 'You must select at least one filter';
    }

    if(data.responsePredicate === 'completed' && !selectedCampaign){
      validationMessages['completed'] = 'You must select an experience';
    }


    if(data.responsePredicate === 'response' && !selectedCampaign){
      validationMessages['response'] = 'You must select an experience';
    } else if(data.responsePredicate === 'response' && !selectedEngagement){
      validationMessages['response'] = 'You must select an activity';
    } else if(data.responsePredicate === 'response' && !data.multipleAnswer ){
      if(!data.answer){
        validationMessages['response'] = 'You must select a response';
      }
    } else if(data.responsePredicate === 'response' && data.multipleAnswer){


      selectedResponses = Object.keys(data.multipleAnswer)
        .filter((answer) => data.multipleAnswer[answer] === 'on');

      if(selectedEngagement.options.length === selectedResponses.length){
        validationMessages['response'] = 'You can not select all responses';
      }
    }



    if(selectedCampaign && selectedCampaign.status === 'active'){
      this.setState({selectedCampaignIsActive:true});
    } else {
      this.setState({selectedCampaignIsActive:false});
    }

    if(Object.keys(validationMessages).length > 0){
      console.log('VALIDATION ',validationMessages);
      this.setState({validationMessages:validationMessages});
      return;
    } else {
      this.setState({validationMessages:{},isSaving:true});

      const targetingConfig = this.formatTargetingConfig(data);

      targetCampaign(campaignId,targetingConfig)
        .then((res) => {
          const reach = res; //TODO FORMAT THIS

          this.setState({
            isSaving:false,
            hasClickedSave:true,
            estimatedReach:reach
          });
        });
    }
  }

  formatTargetingConfig(data){
    let predicate,filters,constraints;
    const {constraintExclude} = this.state

    if(data.geofilterPredicate === 'all'){
      predicate = null;
      filters = [];
    } else if(data.geofilterPredicate === 'zip'){
      predicate = 'zip';
      filters = [];
    }
    else if(data.geofilterPredicate === 'exclude'){
      predicate = 'exclude';
      filters = data.excludedFilters;
    } else {
      predicate = 'include';
      filters = data.includedFilters;
    }

    if(data.responsePredicate === 'all'){
      constraints = null
    } else if(data.responsePredicate === 'user'){
      constraints = [{
        filterType: constraintExclude !== true ? 2 : 3,
        exclude: constraintExclude
      }];
    }  else if(data.responsePredicate === 'completed'){

      constraints = [{
        filterType:0,
        exclude: constraintExclude,
        requiredCampaignId:data.completedCampaignId
      }];

    } else {
      if(data.multipleAnswer){
        constraints = Object.keys(data.multipleAnswer)
          .filter((answer) => data.multipleAnswer[answer] === 'on')
          .map((answer) => ({
            filterType:1,
            exclude: constraintExclude,
            requiredCampaignId:data.responseCampaignId,
            engagementId:data.responseEngagementId,
            value:answer
          }));

      } else {
        constraints = [{
          filterType:1,
          exclude: constraintExclude,
          requiredCampaignId:data.responseCampaignId,
          engagementId:data.responseEngagementId,
          value:data.answer
        }];
      }
    }

    return {
      predicate:predicate,
      filters:filters,
      constraints:constraints
    }
  }


  handleNextClick(){
    const { forwardURL, campaignId, submitCampaign, history, showNotification } = this.props,
      url = forwardURL ? forwardURL : `/welcome/tutorial/${campaignId}/review`;

    history.push(url);

  }

  handleBackClick(){
    const { backURL, campaignId, history } = this.props,
      url = backURL ? backURL : `/welcome/tutorial/${campaignId}/payment`;

    history.push(url);
  }

  getSaveButtonText(){
    if(this.state.hasClickedSave){
      if(this.state.isSaving){
        return 'Updating';
      } else {
        return 'Update';
      }
    } else {
      if(this.state.isSaving){
        return 'Saving';
      } else {
        return 'Save';
      }
    }
  }

  getResponsePredicateSections() {
    const {
      isLoaded,
      estimatedReach,
      validationMessages
    } = this.state;
    let sections = [
      {
        name:'all',
        singleOption: true,
        display:'None',
        tooltip:'All consumers associated with the defined publisher(s) may receive your experience'
      },
      {
        name:'completed',
        singleOption: false,
        display:'By Completed Experience',
        tooltip:'Include/Exclude consumers who have completed the selected experience may receive your experience',
        renderSection:(exclude) => isLoaded ? (
          <CampaignCompletionInput
            campaigns={ exclude === true ? this.props.campaignFilters.filter(c => ['complete','outOfFunds'].indexOf(c.status) >= 0) : this.props.campaignFilters}
              onChange={() => this.setState({estimatedReach:null,validationMessages:{}})}
              onCampaignChange={(e) => {}}
              defaultValue={this.props.activeCampaignConstraints}
              warning={validationMessages['completed']}
            />
        ) :(
          <span>Loading...</span>
        )
      },
      {
        name:'response',
        singleOption: false,
        display:'By Specific Response Criteria',
        tooltip:'Include/Exclude consumers who have completed the selected experience and responded to an activity in a particular way',
        renderSection:(exclude) => isLoaded ? (
          <EngagementResponseInput
            campaigns={ exclude === true ? this.props.campaignFilters.filter(c => ['complete','outOfFunds'].indexOf(c.status) >= 0) : this.props.campaignFilters}
            campaignKpis={this.props.campaignKpis}
            onChange={() => this.setState({estimatedReach:null,validationMessages:{}})}
            onCampaignChange={(id) => this.props.loadKPIsForCampaign(id)}
            onEngagementChange={(id) => {}}
            onChoiceChange={(choices) => {}}
            defaultValue={this.props.activeCampaignConstraints}
            warning={validationMessages['response']}
          />
        ) :(
          <span>Loading...</span>
        )
      }
    ]
    if (this.props.activeUser.isProvider) {
      sections.push({
        name:'user',
        singleOption: false,
        display:'Custom',
        tooltip:'Custom targeting by including/excluding users as agreed with Dabbl'
      });
    }
    return sections;
  }

  render(){

    const {
      selectedPredicate,
      selectedResponsePredicate,
      tooltipPredicate,
      isLoaded,
      isSaving,
      hasClickedSave,
      estimatedReach,
      validationMessages,
      noOverLap,
      selectedCampaignIsActive
    } = this.state

    const {
      isOnboarding,
      possibleStates,
      geofilters,
      activeCampaignStates,
      activeCampaignGeoFilterPredicate,
      activeCampaignFilters,
      activeCampaignConstraints,
      exclude,
      campaignFilters,
      campaignKpis
    } = this.props;

    const activeConstraint = typeOfContraints(activeCampaignConstraints)

    return (
      <div className='GuidedCampaignAudience'>
        <Row>
          <Col xs='12'>
            <br />
            <br />
            <h1>Select your Audience</h1>
            <h6>Who are you trying to reach?</h6>
            <br />
            <Card>
              <CardBody>
                <Form onSubmit={(data) => this.handleSubmit(data)}>
                  <strong>Location</strong>
                  <div>
                    <div>
                      <AudienceRadioInput
                        inputName="geofilterPredicate"
                        inputValue="all"
                        radioName="Nationwide"
                        checked={selectedPredicate === ALL_PREDICATE}
                        handleClick={() => this.setState({selectedPredicate:ALL_PREDICATE,estimatedReach:null})}
                        popover="All consumers in the Dabbl network may receive your experience, including users who have not shared their location."
                      />
                    </div>
                    <div>
                      <AudienceRadioInput
                        inputName="geofilterPredicate"
                        inputValue="include"
                        radioName="Include"
                        checked={selectedPredicate === INCLUDE_PREDICATE}
                        handleClick={() => this.setState({selectedPredicate:INCLUDE_PREDICATE,estimatedReach:null,validationMessages:{}})}
                        popover="Consumers in these states may receive your experience"
                      />
                      <Collapse isOpen={selectedPredicate === INCLUDE_PREDICATE}>
                        <div className='StateInputContainer'>
                          {isLoaded ? (
                            <GeofilterInput
                              name='includedFilters'
                              geofilters={geofilters}
                              defaultValue={activeCampaignGeoFilterPredicate === 'include' ? activeCampaignFilters : []}
                              onChange={() => this.setState({estimatedReach:null,validationMessages:{}})}
                              warning={validationMessages['includedFilters']}
                            />
                          ):(
                          <span>Loading...</span>
                          )}
                        </div>
                      </Collapse>
                    </div>
                    <div>
                      <AudienceRadioInput
                        inputName="geofilterPredicate"
                        inputValue="exclude"
                        radioName="Exclude"
                        checked={selectedPredicate === EXCLUDE_PREDICATE}
                        handleClick={() => this.setState({selectedPredicate:EXCLUDE_PREDICATE,estimatedReach:null,validationMessages:{}})}
                        popover="Consumers in these states will not receive your experience"
                      />
                      <Collapse isOpen={selectedPredicate === EXCLUDE_PREDICATE}>
                        <div className='StateInputContainer'>
                          {isLoaded ? (
                            <GeofilterInput
                              name='excludedFilters'
                              geofilters={geofilters}
                              defaultValue={activeCampaignGeoFilterPredicate === 'exclude' ? activeCampaignFilters : []}
                              onChange={() => this.setState({estimatedReach:null,validationMessages:{}})}
                              warning={validationMessages['excludedFilters']}
                            />
                          ):(
                          <span>Loading...</span>
                          )}
                        </div>
                      </Collapse>
                    </div>
                    {this.props.activeUser.isProvider &&
                    <div>
                      <AudienceRadioInput
                        inputName="geofilterPredicate"
                        inputValue="zip"
                        radioName="Custom"
                        checked={selectedPredicate === CUSTOM_PREDICATE}
                        handleClick={() => this.setState({selectedPredicate:CUSTOM_PREDICATE,estimatedReach:null})}
                        popover="Client provides a list of zip codes to target experience to only users in those areas."
                      />
                    </div>
                    }
                  </div>
                  <br />
                  <strong>Response Targeting</strong>
                  <RadioButtonAccordion
                    name='responsePredicate'
                    defaultValue={activeConstraint.name}
                    exclude={activeConstraint.exclude}
                    onChange={(section, exclude) => this.setState({estimatedReach:null,validationMessages:{}, constraintName: section, constraintExclude: exclude})}
                    sections={this.getResponsePredicateSections()}
                  />
                  <br />
                  <br />
                  <Button
                    size='sm'
                    color='primary'
                    disabled={!!isSaving || !isLoaded}
                    type='submit'
                  >
                    &nbsp;&nbsp;{this.getSaveButtonText()}&nbsp;&nbsp;
                  </Button>
                  {(estimatedReach !== null && estimatedReach <= 0) ? (
                    <strong>&nbsp;&nbsp;&nbsp;&nbsp;No matching audience zip codes within location and response targeting criteria. Please update to continue.</strong>
                  ) : null}
                  {(estimatedReach !== null  && estimatedReach > 0) ? (
                    <strong>&nbsp;&nbsp;&nbsp;&nbsp;Estimated Reach:  {(estimatedReach || 0).toLocaleString()} consumers</strong>
                  ) : null}
                  {(estimatedReach !== null  && estimatedReach > 0 && selectedCampaignIsActive) ? (
                    <div style={{marginLeft:111}}>
                      * Reach estimates may not include consumers from active experiences
                    </div>
                  ) :null}
                </Form>
              </CardBody>
            </Card>
            <br />
            <div>
              <Button
                color="primary"
                disabled={!isLoaded || !hasClickedSave || estimatedReach <= 0}
                onClick={() => this.handleNextClick()}
              >
                &nbsp;&nbsp;{isOnboarding ? 'Next: payment' : 'Next: review & submit'}&nbsp;&nbsp;
              </Button>
              &nbsp;&nbsp;
              <Button onClick={() => this.handleBackClick()}>
                &nbsp;&nbsp;Back&nbsp;&nbsp;
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

GuidedCampaignAudience.propTypes = {
  //TODO: Fill in prop types for GuidedCampaignAudience
};

GuidedCampaignAudience.defaultProps = {
  //TODO: Fill in defaultProps for GuidedCampaignAudience
};

export default GuidedCampaignAudience;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignAudience/components/GuidedCampaignAudience.js